import React from 'react';

import { Button } from '@mui/material';

import classes from './NutritionRegistrationBlock.module.scss';
import { redirectTo } from '../../../shared/utils/windowUtils';

type NutritionRegistrationBlockProps = {
  nutritionRegistrationUrl?: string;
  videoUrl?: string;
};

const videoName = 'Nutrition Account Tutorial';

const NutritionRegistrationBlock = ({
  nutritionRegistrationUrl,
  videoUrl,
}: NutritionRegistrationBlockProps) => {
  const handleRegisterClick = () => {
    if (nutritionRegistrationUrl) {
      redirectTo(nutritionRegistrationUrl);
    }
  };

  return (
    <div className={classes.container}>
      {videoUrl && (
        <iframe
          src={videoUrl}
          title={videoName}
          allowFullScreen
          className={classes.video}
        />
      )}
      {nutritionRegistrationUrl && (
        <Button fullWidth variant="contained" onClick={handleRegisterClick}>
          Register Here
        </Button>
      )}
    </div>
  );
};

export { NutritionRegistrationBlock };
